import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PhoneService } from '../phone.service';
import { CallService } from '../../lib';

@Component({
  selector: 'app-consult-transfer',
  templateUrl: './consult-transfer.component.html'
})
export class ConsultTransferComponent {
  phoneNumber: string = '';

  constructor(public dialogRef: MatDialogRef<ConsultTransferComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private phoneService: PhoneService,
   private callService: CallService) {
  }
  closeDialog() {
    this.dialogRef.close();
  }
  validateInput(event: KeyboardEvent): boolean {
    return this.phoneService.validateInput(event, this.phoneNumber)
  }
  consulted() {
    this.callService.apiCallConsultPost({
      address: this.phoneNumber,
      conversationId: this.data.conversationId,
      customerParticipantId: this.data.customerParticipantId
    }).subscribe((response) => {
      this.dialogRef.close();
    })
  }

  blindTransfer() {
    this.callService.apiCallTransferPost({
      address: this.phoneNumber,
      conversationId: this.data.conversationId,
      customerParticipantId: this.data.customerParticipantId,
      agentParticipantId: this.data.agentParticipantId
    }).subscribe((response) => {
      this.dialogRef.close();
    })
  }
}
